document.addEventListener('DOMContentLoaded', function () {
	const fixedButton = document.getElementById('fixed-button');
	const revealDelay = bds_theme.features.fixed_button.reveal_delay || 3000;

	if (fixedButton && fixedButton.classList.contains('reveal-text')) {
		setTimeout(function () {
			fixedButton.classList.remove('expanded');
		}, revealDelay);

		fixedButton.addEventListener('mouseenter', function () {
			fixedButton.classList.add('expanded');
		});

		fixedButton.addEventListener('mouseleave', function () {
			fixedButton.classList.remove('expanded');
		});
	}
});
